import React from "react";
import styled from "styled-components";

import LinkedInIcon from "../Images/circle-linkedin-512.webp";
import wp from "../Images/whatsapplogo.png";

const Container = styled.div`
  position: fixed;
  right: 1%;
  padding: 5px 5px;
  background: rgba(255,255,255,0.9);
  box-shadow: 0px 4px 5px;
  border-radius: 12px;
  cursor: pointer;
  z-index: 99;
  transition: 0.2s ease-in-out;
  font-weight: bold;
  font-family: Arial;
  color:red;
  font-size:0.8rem;
  text-align:center;

  &:hover {
    transform: scale(1.05);
  }
`;

const Icon = styled.img`
  width: ${(props) => props.size || "40px"};
  border-radius: ${(props) => props.radius || "50%"};
  margin-right: 10px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SideIconsWrapper = styled.div``;

export default function SideIcons() {
  const mainUrl = window.location.origin;

  return (
    <SideIconsWrapper>
      {/* Past Projects */}
      <Container style={{ top: "13%" }}
        onClick={() => window.open(`${mainUrl}/pastprojects`, "_blank")}
      >
        PAST <br/>PROJECTS
      </Container>

      {/* Cover Letter */}
      <Container style={{ top: "22%" }}
         onClick={(e) => {
      e.preventDefault();
      // Pass the index as a query parameter
      window.open(`https://drive.google.com/file/d/1RQdarWvtHVI0zSmosqFb2CAhAoLr0vmI/view?usp=sharing`, "_blank", "noopener,noreferrer");
    }}
      >
        COVER <br/>LETTER
      </Container>

        <Container style={{ top: "31%" }}
         onClick={(e) => {
      e.preventDefault();
      // Pass the index as a query parameter
      window.open(`https://drive.google.com/file/d/1xQZj-SoRIySSPNxlUk7BFviJ8cC9kL7c/view?usp=sharing`, "_blank", "noopener,noreferrer");
    }}
      >
        MY CV
      </Container>

      {/* Credentials */}
      <Container style={{ top: "37%" }}
          onClick={(e) => {
      e.preventDefault();
      // Pass the index as a query parameter
      window.open(`https://drive.google.com/file/d/1sUNE7J6-FIB8KjIQ3KIpHwX9vwyGcTWL/view?usp=sharing`, "_blank", "noopener,noreferrer");
    }}
        
      >
        CREDENTIALS
      </Container>

      {/* LinkedIn */}
      <Container style={{ top: "44%", background:"none" }}
        onClick={() => window.open("https://www.linkedin.com/in/engr-chinedu-ndu-41a5a349/", "_blank")}
      >
        <Row>
          <Icon src={LinkedInIcon} size="35px" />
        
        </Row>
      </Container>

      {/* WhatsApp */}
      <Container style={{ top: "54%", background:"none" }}
        onClick={() => window.open("https://wa.me/2348030906974", "_blank")}
      >
        <Row>
          <Icon src={wp} size="45px" />
        </Row>
      </Container>
    </SideIconsWrapper>
  );
}